import { useApplicationApiRequest } from './useApplicationApi'

export default function useVariants(origins = []) {
  const request = useApplicationApiRequest('/hackathon/variants', {
    params: { origins },
  })

  return request
}
